import { Controller, FieldValues } from "react-hook-form"
import { IFormControl } from "src/types/index"
import { InputProps } from "."
import "./style.scss"

type FormInputProps<T extends FieldValues> = InputProps & IFormControl<T>

export const FormInput = <T extends FieldValues>({ label, ...props }: FormInputProps<T>) => {
  const { control, name, rules, required, style, inputProps, ...rest } = props
  return (
    <Controller
      {...{ control, name, rules: { required: { value: required ?? false, message: "This field is required" }, ...rules } }}
      render={({ field, fieldState: { error } }) => (
        <div>
          <label className="custom-input" {...{ style }}>
            {label != null && <span className="custom-input__label">{label}</span>}
            <input {...rest} {...field} {...inputProps} />
          </label>
          {error?.message != null && <span className="custom-input__error">{error.message}</span>}
        </div>
      )}
    />
  )
}
